import { render, staticRenderFns } from "./barras.vue?vue&type=template&id=2ccfd096&scoped=true"
import script from "./barras.vue?vue&type=script&lang=js"
export * from "./barras.vue?vue&type=script&lang=js"
import style0 from "./barras.vue?vue&type=style&index=0&id=2ccfd096&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ccfd096",
  null
  
)

export default component.exports